import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import OtpInput from 'react-otp-input';
import { Formik, Form, ErrorMessage } from 'formik';
import { VerifyOTPSchema } from '../../validation';

import { sendOTP, sendOTPForSocial, verifyOTP } from '../../actions'
import { PAGE_ROUTES } from '../../../../constants/pageRoutes';
import { MAGIC_NUMBER } from '../../../../constants/magicNumbers';

import ShowSuccessToasts from '../../../global/successToast';
import ShowErrorToasts from '../../../global/errorToast';
import { getSearchQuery, navigateTo, pushError } from '../../../global/actions';

const mapStateToProps = state => ({
  registration: state.Registration,
});

class VerifyOTPForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      timeLastUpdated: undefined
    }

    this.onBack = this.onBack.bind(this);
    this.handleOTPChange = this.handleOTPChange.bind(this);
    this.sendOTPToDevice = this.sendOTPToDevice.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.isVerifyingSocialLogin = this.isVerifyingSocialLogin.bind(this);
  }

  componentDidMount() {
    const { registration, dispatch } = this.props;
    if (!registration.formData.phoneNumber) {
      dispatch(navigateTo(PAGE_ROUTES.LOGIN));
    }
  }

  isVerifyingSocialLogin = () => {
    const query = getSearchQuery();
    return !!query.social;
  }

  onBack = () => {
    let { history } = this.props;
    history.goBack();
  }

  sendOTPToDevice = (formProps) => {
    let { dispatch, registration } = this.props;
    let { firstName, lastName, userType, phoneNumber, email, password } = this.props.registration.formData;

    const currentTime = new Date();

    if (!!this.state.timeLastUpdated) {
      const secondsDiff = (currentTime.getTime() - this.state.timeLastUpdated.getTime()) / 1000;
      if (secondsDiff <= MAGIC_NUMBER.OTP_RESEND_WAIT) {
        const leftTime = Math.floor(MAGIC_NUMBER.OTP_RESEND_WAIT - secondsDiff);
        dispatch(pushError(`Please wait ${leftTime} second${leftTime == 1 ? '' : 's'} more before resending.`));
        return;
      }
    }

    if (this.isVerifyingSocialLogin()) {
      dispatch(sendOTPForSocial(phoneNumber, registration.tempUserId));
    }
    else {
      dispatch(sendOTP(firstName, lastName, userType, phoneNumber, email, password));
    }

    this.handleOTPChange('', formProps);
    this.setState({ timeLastUpdated: currentTime })
  }

  handleOTPChange = (otp, formProps) => {
    formProps.setFieldValue("otp", otp);
  }

  handleSubmit = (values, form) => {
    let { dispatch } = this.props;
    let { userType, phoneNumber } = this.props.registration.formData;
    let { tempUserId } = this.props.registration;
    console.log(tempUserId);
    dispatch(verifyOTP(userType, phoneNumber, values.otp, this.isVerifyingSocialLogin() ? tempUserId : undefined));
  }

  // OTP auto-verify
  componentDidMount() {
    let { dispatch } = this.props;
    let { userType, phoneNumber } = this.props.registration.formData;
    let { tempUserId } = this.props.registration;
    dispatch(verifyOTP(userType, phoneNumber, '000000', this.isVerifyingSocialLogin() ? tempUserId : undefined));
  }

  render() {

    let values = this.props.registration.formData;

    return (

      <div className="main-container">
        <ShowErrorToasts />
        <ShowSuccessToasts />
        <div className="main-wrapper">
          <div className="left-section">
            <div className="white-background">
              <div className="content-section">
                <h1 className="title">Verify Phone Number</h1>
                <p className="detail-text" hidden>{`A verification OTP has been sent to your phone number. Please enter ${MAGIC_NUMBER.OTP_DIGITS}-digit verification OTP below.`}</p>
                <p class="detail-text">Please wait while we are verifying...</p>
                <div className="verify-page" hidden>
                  <Formik
                    validationSchema={VerifyOTPSchema}
                    initialValues={{ ...values, otp: '' }}
                    onSubmit={this.handleSubmit}>
                    {formProps => (
                      <Form>
                        <div className="number-verify-section">
                          <div className="input-box">
                            <input type="phone" className="form-control" name="phone" placeholder="Phone Number" value={values.phoneNumber} disabled />
                            <button type="button" className="btn link" onClick={this.onBack}>Edit</button>
                          </div>
                          <div className="resend-btn">
                            <button type="button" className="btn secondary" onClick={() => { this.sendOTPToDevice(formProps) }}>Resend</button>
                          </div>
                        </div>
                        <OtpInput
                          value={formProps.values.otp}
                          onChange={(value) => { this.handleOTPChange(value, formProps) }}
                          numInputs={MAGIC_NUMBER.OTP_DIGITS}
                          className="input-box"
                          containerStyle="password-type-section"
                          inputStyle="form-control"
                          isInputNum
                        />
                        <ErrorMessage name='otp' render={msg => <div className="invalid-feedback">{msg}</div>} />
                        <div className="signin-button">
                          <button type="submit" className="btn primary">Verify Now</button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
          <div className="right-section">
            <div className="bg-image"></div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps)(VerifyOTPForm));
